<template>
  <div class="index-container Base">
    <Layout></Layout>
  </div>
</template>

<script>

import Layout from '@c/layout/Layout';

export default {
  name: 'BasePage',
  components: {
    Layout
  },
  data() {
    return {};
  },

  computed: {},
  created() {},

  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.index-container {
  height: 100%;
}
</style>
